import {httpClient} from "./httpClient";

export type PoolAddress = {
    id: string;
    generated_address: string;
    address_type: number;
    wif_private_key: string;
    hex_private_key: string;
    balance: number;
    total_received: number;
    created_at: string;
    updated_at: string;
};

export type GetPoolAddressesRequest = {
    take: number;
    offset: number;
    sort_by: "created_at" | "address_type" | "generated_address" | "balance" | "updated_at";
    sort_order: "asc" | "desc";
    address_type?: number;
};

export type GetPoolAddressesResponse = {
    items: PoolAddress[];
    total: number;
};

export async function getPoolAddresses(
    params: GetPoolAddressesRequest
): Promise<GetPoolAddressesResponse> {
    const {data} = await httpClient.post<GetPoolAddressesResponse>(
        "/poolAddress/getList",
        params
    );
    return data;
}

export type PoolStats = {
    total_bots: number;
    online_bots: number;
    pool_balance: number;
    pool_count: number;
};

export async function getPoolStats(): Promise<PoolStats> {
    const {data} = await httpClient.get<PoolStats>("/poolAddress/stats");
    return data;
}

export type ExportFilter = "all" | "with_balance";

export async function exportPoolAddresses(filter: ExportFilter = "all"): Promise<void> {
    const response = await httpClient.post("/poolAddress/export", {filter}, {
        responseType: "blob",
    });

    const disposition = response.headers["content-disposition"];
    let filename = "pool_private_keys.txt";
    if (disposition) {
        const match = disposition.match(/filename="?([^";\n]+)"?/);
        if (match?.[1]) filename = match[1];
    }

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
}
